import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import LoadingModal from "../Common/Modal/LoadingModal";
import { Toaster } from "react-hot-toast";
import { Button, Form, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SideBar from "../Common/SideBar/SideBar";
import Header from "../Common/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import WareHouseDWPurchase from "../Common/CustomSelect/WareHouseDWPurchase";
import useAdjust from "../Hooks/useAdjust";
import {
  resetAdjust,
  selectNote,
  selectProducts,
  selectStatus,
  selectWareHouse
} from "../../features/adjustSlice";
import * as Icons from "heroicons-react";
import DamageNewProductSelect from "../Common/CustomSelect/DamageNewProductSelect";
import AdjustProductImporter from "../Common/CsvImporter/AdjustProductImporter";
import { notify } from "../Utility/Notify";
import axios from "axios";
import AdjustProducts from "./AdjustProducts";
import { apiUniqueErrHandle } from "../Utility/Utility";
import { useAddAdjustMutation } from "../../services/adjustApi";
import { signInUser } from "../Utility/Auth";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const CreateAdjust = () => {
  const user = signInUser();
  const { aamarId, warehouse } = user;
  let i = 1;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [wh, setWh] = useState("");

  const [onShow, setOnShow] = useState(false);
  const handleClose = () => setOnShow(false);

  const adjustNewProductsRef = useRef(null);

  const [csvData, setCsvData] = useState([]);
  const [adjustProducts, setAdjustProducts] = useState([]);

  const { totalItems } = useAdjust();
  const adjustData = useSelector((state) => state.adjustReducer);
  const { total_item, total, productList } = totalItems(adjustData?.products || []);

  const [addAdjust] = useAddAdjustMutation();

  const handleOnchangeWareHouse = (e) => {
    setWh(e.option);
    dispatch(selectWareHouse(e.option));
  };

  const handleAdjustSubmit = async () => {
    const selectedWarehouse = wh || adjustData?.warehouse || warehouse;
    if (!selectedWarehouse || selectedWarehouse === "0") {
      notify("Please select a warehouse", "error");
      return;
    }

    if (!adjustData?.products || adjustData.products.length === 0) {
      notify("There must be products for Adjust", "error");
      return;
    }

    const updatedProducts = adjustData.products.map((p) => ({
      ...p,
      warehouse: selectedWarehouse,
      aamarId: aamarId,
      tp: p.tp !== undefined ? String(p.tp) : "0",
      qty: Number(p.qty) || 1,
    }));

    const newAdjust = {
      ...adjustData,
      products: updatedProducts,
      total: Number(total) || 0,
      totalItem: updatedProducts.length,
      aamarId,
      warehouse: selectedWarehouse,
      userId: user?.id || user?._id,
    };

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Wanna create Adjust?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, create it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await addAdjust(newAdjust);
        if (response?.error) {
          if (response.error?.status === 500) {
            apiUniqueErrHandle(response.error.data);
          } else {
            notify(
              response.error?.data?.message ||
                response.error?.data?.error ||
                "Failed to create adjust",
              "error"
            );
          }
        } else {
          dispatch(resetAdjust());
          setAdjustProducts([]);
          notify("Adjust Creation update successful!", "success");
          navigate("/adjust");
        }
      } catch (err) {
        console.log(err);
        notify("Something went wrong", "error");
      }
    }
  };

  const emptyAdjust = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Refresh Cart! Start New Adjust?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reset it!",
    });

    if (result.isConfirmed) {
      setAdjustProducts([]);
      dispatch(selectProducts([]));
    } else {
      console.log("Refresh Operation Cancelled by User");
    }
  };

  const addToList = async (data) => {
    if (data) {
      adjustNewProductsRef.current?.blur?.();
      let listData = adjustData?.products || [];

      // unique check
      const idExist = listData?.find(
        (pro) => pro.id === data._id || pro.article_code === data.article_code
      );
      if (idExist) {
        notify("Product Already in List", "error");
        return false;
      } else {
        notify("Product is Added", "success");

        const selectedWarehouse = wh || adjustData?.warehouse || warehouse;

        const newProduct = {
          id: data?._id,
          name: data?.name,
          article_code: data?.article_code,
          qty: 1,
          order: listData?.length + 1,
          priceId: data?.priceList?.[0]?._id || null,
          tp:
            data?.priceList?.[0]?.tp !== undefined
              ? Number(data.priceList[0].tp)
              : 0,
          aamarId: aamarId,
          warehouse: selectedWarehouse,
          reason: "",
          type: true,
        };
        listData = [...listData, newProduct];
        setAdjustProducts(listData);
        dispatch(selectProducts(listData));
        return true;
      }
    }
    return false;
  };

  const handleImportButton = () => {
    let importProducts = [];
    let i = 1;
    setOnShow(true);
    const selectedWarehouse = wh || adjustData?.warehouse || warehouse;
    if (csvData?.length > 0) {
      csvData.map(async (pro) => {
        try {
          const details = await axios(
            `${BASE_URL}product/pro-details/${pro.article_code}`
          );
          if (details.status === 200) {
            const data = details.data;
            importProducts = [
              ...importProducts,
              {
                id: data?._id,
                article_code: data?.article_code,
                priceId: data?.priceList?.[0]?._id || null,
                tp:
                  data?.priceList?.[0]?.tp !== undefined
                    ? Number(data.priceList[0].tp)
                    : 0,
                name: data?.name,
                qty: Number(pro.qty) || 1,
                type:
                  String(pro.type).trim().toLowerCase() === "out" ? false : true,
                tax: 0,
                discount: 0,
                order: i++,
                aamarId: aamarId,
                warehouse: selectedWarehouse,
                reason: pro.reason || "",
              },
            ];
            setAdjustProducts(importProducts);
          }
        } catch (err) {
          console.log(err);
          notify(err?.message || "Failed to import product", "error");
        } finally {
          dispatch(selectProducts(importProducts));
          if (importProducts?.length === csvData?.length) {
            setOnShow(false);
          }
        }
      });
    } else {
      setOnShow(false);
      notify("There is no products to import", "error");
    }
  };

  const handleOnChangePrice = async (id, e) => {
    try {
      let price = await axios.get(`${BASE_URL}price/${e.option}`);
      if (price.data) {
        const updated = (adjustData?.products || []).map((item) =>
          item.id === id || item.article_code === id
            ? {
                ...item,
                tp:
                  price.data?.tp !== undefined
                    ? Number(price.data.tp)
                    : item.tp,
                priceId: price.data?._id || item.priceId,
              }
            : item
        );
        setAdjustProducts(updated);
        dispatch(selectProducts(updated));
      }
    } catch (err) {
      notify(err?.message || "Failed to update price", "error");
    }
  };

  const handleCustomQty = (qty, id) => {
    const updated = (adjustData?.products || []).map((p) =>
      p.article_code === id ? { ...p, qty: qty } : p
    );
    setAdjustProducts(updated);
    dispatch(selectProducts(updated));
  };

  const handleCustomReason = (reason, id) => {
    const updated = (adjustData?.products || []).map((p) =>
      p.article_code === id ? { ...p, reason: reason } : p
    );
    setAdjustProducts(updated);
    dispatch(selectProducts(updated));
  };

  const removeFromCart = (id) => {
    const rest = (adjustData?.products || []).filter(
      (p) => p.id !== id && p.article_code !== id
    );
    setAdjustProducts(rest);
    dispatch(selectProducts(rest));
  };

  const handleDeSelectIsType = (id) => {
    const updated = (adjustData?.products || []).map((p) =>
      p.article_code === id ? { ...p, type: false } : p
    );
    setAdjustProducts(updated);
    dispatch(selectProducts(updated));
  };

  const handleIsType = (id) => {
    const updated = (adjustData?.products || []).map((p) =>
      p.article_code === id ? { ...p, type: true } : p
    );
    setAdjustProducts(updated);
    dispatch(selectProducts(updated));
  };

  return (
    <div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10 mt-2">
            <Header title="Create Adjust"></Header>
            <Form className="pt-3" action="javascript:void(0)">
              <div className="row">
                <div className="col-8">
                  <Form.Group className="" controlId="warehouse">
                    <Form.Label>Warehouse</Form.Label>
                    <WareHouseDWPurchase
                      id="warehouse"
                      name="warehouse"
                      handleOnChange={handleOnchangeWareHouse}
                      wh={wh !== "" ? wh : 0}
                    />
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group className="">
                    <Form.Label>Adjust Status</Form.Label>
                    <Form.Select
                      onChange={(e) => dispatch(selectStatus(e.target.value))}
                    >
                      <option value="active">Active</option>
                      <option disabled value="inactive">
                        Inactive
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-6 my-3">
                  <Form.Label>Adjust Products</Form.Label>
                  <DamageNewProductSelect
                    className="searchProduct"
                    addToList={addToList}
                    damageNewProductsRef={adjustNewProductsRef}
                    warehouse={wh || adjustData?.warehouse || warehouse}
                  ></DamageNewProductSelect>
                </div>
                <div className="col-6 my-3 ">
                  <AdjustProductImporter
                    setCsvData={setCsvData}
                    handleImportButton={handleImportButton}
                    title=""
                  />
                </div>
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">Adjusted Products List</div>
                    <div className="card-body">
                      <Table hover bordered striped className="mt-3 ">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Quantity</th>
                            <th>TP</th>
                            <th>Total</th>
                            <th>Reason</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <AdjustProducts
                            adjustProducts={adjustData?.products}
                            i={i}
                            handleOnChangePrice={handleOnChangePrice}
                            handleCustomQty={handleCustomQty}
                            removeFromCart={removeFromCart}
                            handleCustomReason={handleCustomReason}
                            handleIsType={handleIsType}
                            handleDeSelectIsType={handleDeSelectIsType}
                          ></AdjustProducts>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 my-2">
                  <Form.Group className="" controlId="formBasicEmail">
                    <Form.Label>Note</Form.Label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => dispatch(selectNote(e.target.value))}
                    />
                  </Form.Group>
                </div>
              </div>
              <Table className="bordered striped ">
                <thead>
                  <tr>
                    <th>Total Items:{total_item}</th>
                    <th>Adjust Value: {total?.toFixed(2)} TK</th>
                  </tr>
                </thead>
              </Table>
              <Button
                variant="dark"
                onClick={handleAdjustSubmit}
                className="float-end my-2"
                type="button"
              >
                <Icons.SaveOutline size={20} /> Submit
              </Button>
              <Button
                variant="dark"
                className="float-end my-2 mx-2"
                type="button"
                onClick={emptyAdjust}
              >
                Reset Cart
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <LoadingModal
        onShow={onShow}
        title="Please Wait.."
        handleClose={handleClose}
      />
      <Toaster position="bottom-right" />
    </div>
  );
};

export default CreateAdjust;
